import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EntNivelesAcademicosView from './EntNivelesAcademicosView';
import * as ROUTES from '../../../router/Routes';

const EntNivelesAcademicosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.entNivelesAcademicos}
      routes={[ROUTES.controlEstudios]}
    >
      <EntNivelesAcademicosView />
    </ContainerTemplate>
  );
};

export default EntNivelesAcademicosModule;
